<template>
  <v-row class="manage-account-container pa-3">
    <v-col cols="12" lg="10" xl="5">
      <div
        v-if="loading"
        class="text-center grey--text text--darken-2 mt-4"
        key="loading-settings"
      >
        <h2 class="mt-2">Loading Settings</h2>
        <v-progress-circular
          indeterminate
          class="mt-4"
          color="grey darken-2"
          size="20"
          width="2"
        />
      </div>
      <div
        v-else-if="error"
        class="text-sm-center grey--text text--darken-2 my-6"
        key="loading-error"
      >
        <h2 class="mt-2">Failed to load settings.</h2>
        <v-col cols="12" sm="8" md="6" class="text-h6 mx-auto px-0"
          >There was an error loading your Storefront settings. Please reload
          the page and try again.</v-col
        >
        <div
          ><v-btn
            @click="reloadPage"
            depressed
            color="orange darken-3"
            class="white--text mt-2 mb-2"
            >Reload Page</v-btn
          ></div
        >
      </div>
      <div v-else key="settings" class="settings-form">
        <h2 class="proxima--font font-weight-bold mb-4">Account Details</h2>
        <ManageAccountForm />
        <v-divider class="my-6" />
        <h2 class="proxima--font font-weight-bold mb-4">Password Management</h2>
        <ShopSettingsPassword />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import _includes from 'lodash/includes'
import { mapActions } from 'vuex'
import ShopSettingsPassword from '@/components/ShopSettingsPassword'
import ManageAccountForm from '@/components/ManageAccountForm'

export default {
  name: 'ManageAccount',
  components: {
    ShopSettingsPassword,
    ManageAccountForm,
  },
  meta() {
    return { title: `My Account | Minimart` }
  },
  data: () => {
    return {
      loading: false,
      error: false,
    }
  },
  computed: {},
  methods: {
    ...mapActions('auth', ['fetchAuthMerchant']),
    reloadPage() {
      let href = window.location.href
      window.location.href = href
    }, // reloadPage
    _includes,
  }, // methods
  async created() {
    this.loading = true
    try {
      await this.fetchAuthMerchant()
    } catch (error) {
      this.error = true
    } finally {
      this.loading = false
    }
  },
}
</script>

<style scoped>
.manage-account-container {
  max-width: 600px;
}
</style>
